<template>
  <div>
    <section class="header">
      <a class="icon iconButton third" @click.prevent="goBackTo">
        <font-awesome-icon
          icon="fa-solid fa-chevron-left"
          size="lg"
        ></font-awesome-icon>
      </a>
      <span class="fL">隱私權政策及同意條款</span>
      <div class="icon iconButton"></div>
    </section>

    <section class="main">
      <div id="agreement" class="agreement rounded-2xl bg-white shadow-md fS" v-html="$t('ddwallet-privacy-policy')"></div>

      <div class="btn-wrap">
        <button @click.prevent="onAgree" type="button" class="button loader text-white border-0 flex-1 fM" :disabled="disabled">
          <div v-if="! loading">我已詳閱並同意條款</div>
          <div v-else><div class="loading"></div></div>
        </button>
      </div>
    </section>

    <AlertDialog
      v-if="showAlert"
      :title="alert.title"
      :content="alert.message"
      @close="onCloseAlertDialog"
    />
    <ConfirmDialog
      v-if="showConfirm"
      :initOpen="true"
      :title="confirm.title"
      :content="confirm.message"
      :buttons="confirmDialogButtonConfig"
    />
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import AlertDialog from '@/components/Dialog/AlertDialog.vue';
  import ConfirmDialog from '@/components/Dialog/ConfirmDialog.vue';
  import { ddwallet } from "@/services/ddwallet.js";
  import { buildUrlQuery } from "@/utils/url.js";

  export default {
    components: {
      AlertDialog,
      ConfirmDialog
    },

    data() {
      return {
        disabled: true,
        apiHost: process.env.VUE_APP_API_HOST,
        merchantId: process.env.VUE_APP_MERCHANT_ID,
        redirectUrl: '',
        loading: false,
        showAlert: false,
        alert: {
          title: '',
          message: ''
        },
        showConfirm: false,
        confirm: {
          title: '',
          message: ''
        }
      };
    },

    computed: {
      ...mapState(['user']),
      confirmDialogButtonConfig() {
        return [
          {
            text: "返回",
            outline: true,
            click: () => {
              this.onCloseConfirmDialog();
            },
          },
          {
            text: "確認",
            click: () => {
              this.onCloseConfirmDialog();

              window.open(this.redirectUrl, '_blank', 'noopener,noreferrer');
            },
          },
        ];
      }
    },

    mounted() {
      document.getElementById('agreement').addEventListener('scroll', this.scrollBottomCheck);
    },

    methods: {
      goBackTo() {
        this.$router.push('/profile');
      },

      scrollBottomCheck(e) {
        let scrollableDiv = e.currentTarget;
        if (scrollableDiv.scrollTop + scrollableDiv.clientHeight >= scrollableDiv.scrollHeight - 5) {
          this.disabled = false;
        }
      },

      async onAgree() {
        this.loading = true;
        this.disabled = true;

        try {
          let accountLinkResult = await ddwallet.postAccountLink(this.merchantId, this.user.userId);
          accountLinkResult = ddwallet.useData(accountLinkResult, 'ddwallet.postAccountLink');

          if (accountLinkResult.data.linkUri)
          {
            this.loading = false;
            this.disabled = false;
            
            // Add openExternalBrowser query string for app webview detect need open device browser.
            this.redirectUrl = buildUrlQuery(accountLinkResult.data.linkUri, { openExternalBrowser: 1 });

            this.confirm = {
              title: '提示',
              message: '您即將離開 App 前往外部連結，請問是否繼續？'
            };

            this.showConfirm = true;
          }
        }
        catch (err)
        {
          console.error(err);

          this.loading = false;
          this.disabled = false;

          this.alert = {
            title: '',
            message: '跨域點數服務暫時無法使用，請稍後再試。'
          };

          this.showAlert = true;
        }
      },

      onCloseConfirmDialog() {
        this.showConfirm = false;

        this.confirm = {
          title: '',
          message: ''
        }
      },

      onCloseAlertDialog() {
        this.showAlert = false;

        this.alert = {
          title: '',
          message: ''
        }
      }
    }
  };
</script>

<style scoped>
  .main {
    padding-bottom: 0 !important;
  }

  .agreement {
    padding: 1rem;
    color: var(--cG3);
    min-height: auto;
    height: calc(100dvh - 200px);
    overflow-y: auto;
  }

  .btn-wrap {
    padding: 0.8rem 1.5rem;
  }
</style>